import { GET_ORDER_BOOK, } from "../../interface/orderBook";
const initState = {
    data: {
        type: "",
        ord: [],
    },
};
const EqOrderBookReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_ORDER_BOOK:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        default:
            return state;
    }
};
export default EqOrderBookReducer;
